/* eslint-disable */
export default {
  from: '発信元',
  to: '発信先',
  enterNameOrNumber: '番号または名前を入力...',
  typeMessage: 'メッセージを入力...',
  send: '送信',
  emoji: '絵文字',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
